import React, { FunctionComponent, ReactElement, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import { TestID } from '../../../utils/PropTypesDefinitions'
import TeaserInfo from '../../../TeaserInfo'
import { MatchProps } from '../MatchTypes'
import Match from '..'
import { BetProps } from '../../Bet'
import { SpacingProps } from '../../../utils/styling/StylingHelper'
import { mapSpaceValue } from '../../../Layouts/LayoutUtils'
import TopLabel, { TopLabelProps } from '../../TopLabel'

export type HeadlineProps = {
    text: string
    /** headline image url */
    imageUrl: string
    /** info about imageUrl for seo */
    alt?: string
    /** avoid showing an image inside of the headline */
    hideTagImage?: boolean
    /**
     * callback when the headline is pressed
     * @TJS-type function
     * */
    onPressHeadline?: () => void
}

export type MatchCardProps = {
    headlineProps?: HeadlineProps
    matchProps: MatchProps
    betProps?: BetProps
    isSingleMatch?: boolean
} & TestID &
    Pick<SpacingProps, 'spaceY' | 'spaceTop' | 'spaceBottom'> &
    TopLabelProps

const MatchCard: FunctionComponent<MatchCardProps> = ({
    headlineProps,
    matchProps,
    betProps,
    topLabel,
    isSingleMatch,
    testID,
    spaceY,
    spaceBottom,
    spaceTop,
}): ReactElement => (
    <Grid
        noExpand
        backgroundColor="pearl"
        border="1px"
        borderColor="moon-2"
        borderRadius={4}
        testID={testID}
        marginY={mapSpaceValue(spaceY)}
        marginBottom={mapSpaceValue(spaceBottom)}
        marginTop={mapSpaceValue(spaceTop)}
    >
        {topLabel ? (
            <TopLabel
                topLabel={topLabel}
                marginLeft={[0, 0, 0, 3]}
                marginRight={[0, 0, 0, 384]}
                onPress={matchProps.onPressMatch}
                href={matchProps.matchHref}
            />
        ) : null}
        <Grid noExpand paddingTop={topLabel ? 0 : '6px'}>
            {headlineProps ? (
                <Grid paddingTop={1} paddingX={5}>
                    <Touchable onPress={headlineProps.onPressHeadline}>
                        <TeaserInfo
                            hideTagImage={headlineProps.hideTagImage}
                            name={headlineProps.text}
                            imageUrl={headlineProps.imageUrl}
                            alt={headlineProps.alt}
                        />
                    </Touchable>
                </Grid>
            ) : null}
            <Match
                {...matchProps}
                betProps={matchProps.betProps || betProps}
                paddingTop={['10px', '10px', '10px', '5px']}
                borderRadius={4}
                isSingleMatch={isSingleMatch}
            />
        </Grid>
    </Grid>
)

export default memo(MatchCard)
